(function () {
  var SAME_SITE = /(^|\.)attaquercycling\.com$/i;

  function isExternal(a) {
    if (!a.getAttribute || a.target === '_blank') return false;
    var href = a.getAttribute('href');
    if (!href) return false;
    if (href.charAt(0) === '#' || href.charAt(0) === '/') return false;
    if (/^(mailto:|tel:|sms:|javascript:|data:|blob:)/i.test(href)) return false;
    var u;
    try { u = new URL(href, location.origin); } catch (e) { return false; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    return !SAME_SITE.test(u.hostname);
  }

  function tag(a) {
    if (!isExternal(a)) return;
    a.target = '_blank';
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (token) {
      if (rel.indexOf(token) === -1) rel.push(token);
    });
    a.setAttribute('rel', rel.join(' '));
  }

  function tagAll(root) {
    (root || document).querySelectorAll('a[href]').forEach(tag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tagAll(); });
  } else {
    tagAll();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'A') tag(n);
          else if (n.querySelectorAll) tagAll(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
